/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcelTrackingNumberVo } from './ParcelTrackingNumberVo';
import {
    ParcelTrackingNumberVoFromJSON,
    ParcelTrackingNumberVoFromJSONTyped,
    ParcelTrackingNumberVoToJSON,
    ParcelTrackingNumberVoToJSONTyped,
} from './ParcelTrackingNumberVo';

/**
 * 
 * @export
 * @interface ResponseListParcelTrackingNumberVo
 */
export interface ResponseListParcelTrackingNumberVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListParcelTrackingNumberVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListParcelTrackingNumberVo
     */
    message?: string;
    /**
     * 
     * @type {Array<ParcelTrackingNumberVo>}
     * @memberof ResponseListParcelTrackingNumberVo
     */
    data?: Array<ParcelTrackingNumberVo>;
}

/**
 * Check if a given object implements the ResponseListParcelTrackingNumberVo interface.
 */
export function instanceOfResponseListParcelTrackingNumberVo(value: object): value is ResponseListParcelTrackingNumberVo {
    return true;
}

export function ResponseListParcelTrackingNumberVoFromJSON(json: any): ResponseListParcelTrackingNumberVo {
    return ResponseListParcelTrackingNumberVoFromJSONTyped(json, false);
}

export function ResponseListParcelTrackingNumberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListParcelTrackingNumberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ParcelTrackingNumberVoFromJSON)),
    };
}

export function ResponseListParcelTrackingNumberVoToJSON(json: any): ResponseListParcelTrackingNumberVo {
    return ResponseListParcelTrackingNumberVoToJSONTyped(json, false);
}

export function ResponseListParcelTrackingNumberVoToJSONTyped(value?: ResponseListParcelTrackingNumberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ParcelTrackingNumberVoToJSON)),
    };
}

